"use client";

import { useState } from "react";
import { Card, CardContent } from "@/components/ui/card";
import { Car, Clock, Trash2 } from "lucide-react";
import { format } from "date-fns";
import { Id } from "@convex/_generated/dataModel";
import { DeleteShiftDialog } from "@/components/shifts/delete-shift-dialog";

interface CommuteCardProps {
  commute: {
    _id: string;
    startedAt: number;
    endedAt?: number;
    totalMiles: number;
    pauseDuration: number;
  };
}

export function CommuteCard({ commute }: CommuteCardProps) {
  const [showDelete, setShowDelete] = useState(false);

  const duration = Math.round(
    ((commute.endedAt ?? Date.now()) -
      commute.startedAt -
      (commute.pauseDuration || 0)) /
      60000
  );
  const startTime = format(new Date(commute.startedAt), "h:mm a");
  const dateStr = format(new Date(commute.startedAt), "MMM d");

  return (
    <>
      <Card>
        <CardContent className="p-4 flex items-center justify-between">
          <div className="flex items-center gap-3">
            <div className="h-8 w-8 rounded-full bg-muted flex items-center justify-center">
              <Car className="h-4 w-4" />
            </div>
            <div>
              <p className="font-medium">{startTime}</p>
              <p className="text-sm text-muted-foreground flex items-center gap-1">
                <Clock className="h-3 w-3" />
                {duration} min
              </p>
            </div>
          </div>
          <div className="flex items-center gap-3">
            <p className="text-lg font-semibold">
              {commute.totalMiles.toFixed(1)} mi
            </p>
            <button
              onClick={() => setShowDelete(true)}
              className="p-2 text-muted-foreground hover:text-destructive transition-colors"
            >
              <Trash2 className="h-4 w-4" />
            </button>
          </div>
        </CardContent>
      </Card>

      <DeleteShiftDialog
        shiftId={commute._id as Id<"shifts">}
        shiftDate={dateStr}
        shiftMiles={commute.totalMiles}
        open={showDelete}
        onOpenChange={setShowDelete}
      />
    </>
  );
}
